<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__fps">{{ fps }}</div>
  <div class="footer__button-group">
    <p class="footer__label">Plane type:</p>
    <button
      class="footer__button"
      *ngFor="let planeToolType of planeToolTypesMap.keys()"
      (tap)="selectPlaneTool(planeToolType)"
      [class.is-active]="selectedPlaneTools[planeToolType]"
    >
      {{ planeToolTypesMap.get(planeToolType) }}
    </button>
  </div>
</footer>
